import DeliveryAssign from '../../components/deliveryCommon/DeliveryCommon';

const DeliveryRegular = () => {
	return (
		<DeliveryAssign deliveryType='regular' title='Assign Delivery riders' />
	);
};

export default DeliveryRegular;
